export const isWebView = () =>
    (window && window.isWebview) || window.location.search.includes('nolayout=1');

export const getWebviewTheme = () => window && window.WEBVIEW_THEME;
